import Controller from '@ember/controller';
import { service } from '@ember/service';
import { task, all } from 'ember-concurrency';
import { action } from '@ember/object';
import { waitFor } from '@ember/test-waiters';
import { PERMISSION_NAMES } from 'eflex/constants/user-permissions';

export default class CodesRejectController extends Controller {
  @service validationErrorNotifier;
  @service codeRepo;
  @service currentUser;

  permission = PERMISSION_NAMES.reasonCodes;

  get codes() {
    return this.codeRepo.rejectCodes;
  }

  get hasPermission() {
    return this.currentUser.user.hasPermission(this.permission);
  }

  get isDirty() {
    return this.codes.some(item => item.isDirty);
  }

  get isInvalid() {
    return this.codes.filter(item => !item.isDeleted).some(item => item.isInvalid);
  }

  save = task(waitFor(async () => {
    const toSave = this.codes.filter(item => item.isDirty);

    if (toSave.some(item => item.isInvalid)) {
      this.validationErrorNotifier.sendErrors(toSave);
      return;
    }

    await all(toSave.map(code => code.save()));
  }));

  @action
  rollback() {
    this.codes
      .filter(item => item.isDirty)
      .forEach(code => { code.rollbackAttributes(); });
  }
}
